import React, { useState } from 'react';
import SpiderTBack from "../images/spiderT-back.png"
import SpiderTFront from "../images/spiderT-front.png"
import dressingRoom from "../images/dressing_room_web.jpg"
import { SectionHeader } from "../SectionHeader"
import { BAND_EMAIL } from "../links"
import "./Store.css"

const SIDES = [
    { key: "front", label: "Front", image: SpiderTFront },
    { key: "back", label: "Back", image: SpiderTBack },
]

const orderLink = `mailto:${BAND_EMAIL}?subject=${encodeURIComponent("Spider T order")}`

export const MerchGrid = () => {
    const [sideIndex, setSideIndex] = useState(0)
    const side = SIDES[sideIndex]

    return (
        <div className="lf-merch">
            <div className="lf-product">
                <button
                    className="lf-product__shot"
                    onClick={() => setSideIndex((sideIndex + 1) % SIDES.length)}
                    aria-label="Flip shirt"
                >
                    <span className="lf-product__badge">IN STOCK</span>
                    <img src={side.image} alt={`Spider T ${side.label.toLowerCase()}`} />
                    <span className="lf-product__hint">{sideIndex + 1} / {SIDES.length} — TAP TO FLIP</span>
                </button>

                <div className="lf-product__info">
                    <div className="lf-product__sides">
                        {SIDES.map((s, i) => (
                            <button
                                key={s.key}
                                className={i === sideIndex ? "active" : ""}
                                onClick={() => setSideIndex(i)}
                            >
                                {s.label}
                            </button>
                        ))}
                    </div>
                    <h3>Spider Tee</h3>
                    <div className="lf-product__price">$30</div>
                    <p>Black tee, Lowfye50 logo on the front, spider print on the back.</p>
                    <a className="lf-btn lf-btn--primary" href={orderLink}>
                        <i className="fas fa-envelope"></i> Order by email
                    </a>
                    <small>Shipping price may vary — reach out to {BAND_EMAIL}</small>
                </div>
            </div>

            <div className="lf-product lf-product--soon" style={{ backgroundImage: `url(${dressingRoom})` }}>
                <span>More<br />Coming<br />Soon</span>
            </div>
        </div>
    )
}

export const Store = () => (
    <section className="lf-section" id="merch">
        <div className="lf-wrap">
            <SectionHeader eyebrow="Official store" title="Merch" />
            <MerchGrid />
        </div>
    </section>
)
